import type { HttpErrorResponse } from '@angular/common/http';

import { createActions, ngrxEvent } from '@recruitee/ngrx';
import type { Guest } from '@recruitee/notes-types';

const namespace = 'viewboxGuest';

export const ViewboxGuestActions = createActions(namespace, {
  save: ngrxEvent<{ data: any }>(),
  saveSuccess: ngrxEvent<Guest>(),
  saveFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
